import { IUser } from 'app/services/user';
import Label from 'Components/Form/Label';
import SelectSearchDropDown from 'Components/Form/SearchDropDown/SelectSearchDropDown';
import UserAvatar from 'Components/UserAvatar';

export default function SingleUserSelector({
  userId,
  onChangeId,
  label,
  options,
  isLoading,
  clearable,
  disabled,
  exculde = [],
}: {
  label?: string;
  disabled?: boolean;
  userId?: number;
  isLoading?: boolean;
  onChangeId: (u?: number) => void;
  options?: IUser[];
  clearable?: boolean;
  exculde?: number[];
}) {
  return (
    <>
      {label && <Label label={label} />}
      <SelectSearchDropDown
        valueId={userId}
        isLoading={isLoading}
        disabled={disabled}
        clearable={clearable}
        onChangeId={onChangeId}
        className="w-full"
        options={options || []}
        searchFilter={(search: string, list: IUser[]) => {
          const needle = search.toLocaleLowerCase().trim();
          return list
            .filter((o) => !exculde.includes(o.id))
            .filter((u) => {
              const givenName = u.given_name.toLocaleLowerCase();
              const familyName = u.family_name.toLocaleLowerCase();
              const fullName = givenName + ' ' + familyName;
              return (
                givenName.includes(needle) ||
                familyName.includes(needle) ||
                fullName.includes(needle)
              );
            });
        }}
        placeHolder={<SelectedUser />}
        selectedItemSkin={(user) => <SelectedUser user={user} />}
        optionItemSkin={(user, isActive) => (
          <>
            {user.given_name} {user.family_name}
          </>
        )}
      />
    </>
  );
}

function SelectedUser({ user }: { user?: IUser }) {
  return (
    <div className="flex items-center gap-2">
      <UserAvatar user={user} size="w-7 h-7 text-xs " />
      <span className="text-xs line-clamp-1 text-ellipsis">
        {user && (
          <>
            {user.given_name} {user.family_name}
          </>
        )}
      </span>
    </div>
  );
}
